





























import {
  computed,
  useContext,
  defineComponent,
  PropType,
} from '@nuxtjs/composition-api'
import { difference } from 'ramda'
import { localeWeekDay } from '~/lib/utilities/datetime'
import { HolidayTime, OpeningTimes, RegularTime } from '~/types/store'

export default defineComponent({
  name: 'StoreOpeningTimes',

  props: {
    openingTimes: {
      type: Object as PropType<OpeningTimes>,
      default: () => {},
    },
  },

  setup(props) {
    const { app } = useContext()
    const days = [0, 1, 2, 3, 4, 5, 6]
    const locale = computed(() => app.i18n.locale)

    const regularTimes = computed(() => props.openingTimes.regularTimes)

    const closingTimes = computed<RegularTime[]>(() => {
      if (!regularTimes.value.length) return []

      const closingDays = difference(
        days,
        regularTimes.value.map((period) => period.day)
      )

      return closingDays.map((day) => ({
        day,
      }))
    })

    const finalRegularTimes = computed(() => {
      return [...regularTimes.value, ...closingTimes.value].sort((a, b) => {
        if (a.day === 0 || b.day === 0) {
          return b.day - a.day
        }
        return a.day - b.day
      })
    })

    const holidayTimes = computed<HolidayTime[]>(() => {
      // return (
      //   config.value?.holidays?.map((holiday) => ({
      //     day: holiday,
      //   })) ?? []
      // )
      return []
    })

    return {
      finalRegularTimes,
      holidayTimes,
      localeWeekDay,
      locale
    }
  },
})
